export const managerUsers = {
  usersList: {
    title: "المستخدمون المسجّلون",
    subtitle: "قائمة المستخدمين المسجّلين في المنصة.",
    columns: {
      id: "المعرّف",
      name: "الاسم",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      accommodations: "أماكن الإقامة",
      sends: "الإرسالات",
      checkin: "تسجيل الوصول",
      registeredAt: "تاريخ التسجيل",
    },
    states: {
      demo: "نسخة تجريبية",
      demoEnded: "انتهت النسخة التجريبية",
      subscribed: "مستخدم مشترك",
      subscriptionExpired: "انتهى الاشتراك",
      queryError: "خطأ في الاستعلام",
    },
    deleteAdvisor: {
      confirmMessage: "هل أنت متأكد من حذف المستشار؟",
      confirmHeader: "تأكيد",
    },
  },
  accommodationUser: {
    info: "معلومات مكان الإقامة",
  },
  dataUserOld: {
    accommodationsList: "قائمة أماكن الإقامة",
    createAccommodation: "إنشاء مكان إقامة",
    emptyMessage: "لا توجد أماكن إقامة مسجّلة",
    emptySubMessage: "ستظهر هنا أماكن الإقامة التي سجّلها المستخدم.",
  },
  checkins: {
    title: "عمليات تسجيل الوصول المكتملة",
  },
  checkinsPending: {
    title: "عمليات تسجيل الوصول المعلّقة أو قيد التنفيذ",
  },
};
